var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTropyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 14.9727C10.866 14.9727 14 11.8387 14 7.97266C14 4.10666 10.866 0.972656 7 0.972656C3.13401 0.972656 0 4.10666 0 7.97266C0 11.8387 3.13401 14.9727 7 14.9727Z",
    fill: "#F0FAE5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon Trophy",
    d: "M9.25 7.52266C9.99558 7.52266 10.6 6.91824 10.6 6.17266H11.5C11.5001 6.77727 11.2569 7.3565 10.8252 7.77977C10.3934 8.20304 9.8095 8.43475 9.205 8.42266C9.02473 9.30659 8.33393 9.99738 7.45 10.1777V11.1227L9.7 12.0227V12.4727H4.3V12.0227L6.55 11.1227V10.1777C5.66607 9.99738 4.97527 9.30659 4.795 8.42266H4.75C3.50736 8.42266 2.5 7.4153 2.5 6.17266H3.4C3.4 6.91824 4.00442 7.52266 4.75 7.52266V5.27266H3.4V6.17266H2.5V4.37266H4.75V3.47266H9.25V4.37266H11.5V6.17266H10.6V5.27266H9.25V7.52266Z",
    fill: "#107F47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTropyIcon);
export default __webpack_public_path__ + "static/media/tropy-icon.46de200fd4f1327d16c41f8607183889.svg";
export { ForwardRef as ReactComponent };